export default class BlockProfiles {
    constructor() {
        if (window.acf) {
            // Editor
            window.acf.addAction('render_block_preview/type=iris-block-profiles', () => {
                import(
                    '@iris.interactive/handcook/public/scripts/components/slider/slider.component' /* webpackChunkName: "scripts/hc_slider" */
                ).then(({ default: hc_slider }) => {
                    hc_slider()
                })
            })
        }
    }
}

new BlockProfiles()
